export enum Permission {
    IS_SUPER_ADMIN = 'IsSuperAdmin',
    ADMIN = 'Admin',
    EDITOR = 'Editor',
}
